"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../../lib/utils");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondaryLinks = function SecondaryLinks(props) {
  var _user$companies;

  var user = props.user,
      handleSignOut = props.handleSignOut,
      currentPage = props.currentPage,
      unreadCount = props.unreadCount,
      handleAuthAction = props.handleAuthAction,
      setMobileMenu = props.setMobileMenu,
      openSwitchCompanyModal = props.openSwitchCompanyModal,
      showAuthLinks = props.showAuthLinks;
  var hasCompany = user && !!user.company;
  var messagesClasses = (0, _classnames.default)({
    'new-messages': unreadCount
  });

  var LogInSection = function LogInSection() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !user && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
      onClick: function onClick() {
        handleAuthAction('login');
        (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_login"));
      }
    }, "Log In")), !user ? /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
      onClick: function onClick() {
        handleAuthAction('signup');
        (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_signup"))();
      }
    }, "Sign Up")) : /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
      onClick: function onClick() {
        handleSignOut();
        (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_logout"))();
      }
    }, "Log Out")));
  };

  var DashSection = function DashSection() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/dash/a/profile",
      onClick: function onClick() {
        return setMobileMenu(false)();
      }
    }, "Profile")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/dash/a/company",
      onClick: function onClick() {
        return setMobileMenu(false)();
      }
    }, "Account Settings")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/dash/a/resource-center",
      onClick: function onClick() {
        return setMobileMenu(false)();
      }
    }, "Resource Center")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/dash",
      onClick: function onClick() {
        return setMobileMenu(false)();
      }
    }, "Live Support")));
  };

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "mobile-secondary-links"
  }, hasCompany && currentPage !== 'dash' && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/dash",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_mydash"))
  }, "My Dashboard")), currentPage === 'dash' && DashSection(), currentPage !== 'home' && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "http://help.everdays.com/using-everdays-at-your-funeral-home",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_help_center"))
  }, "FAQ / Help Desk")), currentPage === 'dash' && openSwitchCompanyModal && !!(user !== null && user !== void 0 && (_user$companies = user.companies) !== null && _user$companies !== void 0 && _user$companies.length) && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
    onClick: function onClick() {
      openSwitchCompanyModal();
      setMobileMenu(false)();
    }
  }, "Switch Account")), showAuthLinks && LogInSection(), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/terms",
    onClick: function onClick() {
      (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_terms"))();
    }
  }, "Terms of Service")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/privacy",
    onClick: function onClick() {
      (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_privacy"))();
    }
  }, "Privacy Policy")), user && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", {
    onClick: function onClick() {
      handleSignOut();
      (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_logout"))();
    }
  }, "Log Out")));
};

var _default = SecondaryLinks;
exports.default = _default;